const general = {
  name: {
    presence: {
      allowEmpty: false,
      message: "Nome é obrigatório."
    }
  },
  variation_options: {
    length: {
      minimum: 1,
      maximum: 5,
      message: "Informe no mínimo 1 variação."
    }
  }
};

export default {
  general
};



// WEBPACK FOOTER //
// ./src/core/constraint/variation.constraint.js